export interface DisplayAddressSource {
  roadAddressEn?: string | null;
  jibunAddressEn?: string | null;
  detail?: string | null; // 영문/원문 상세
  legacy?: string | null; // 4축이 없을 때의 폴백 단일 문자열
}

export interface DisplayAddress {
  road?: string;
  jibun?: string;
  detail?: string;
  fallbackLine?: string; // road·jibun 둘 다 없을 때만 채워짐
}

const COUNTRY_SUFFIX = /,\s*(Republic of Korea|South Korea)\s*$/i;

const clean = (v?: string | null): string | undefined => {
  if (!v) return undefined;
  const trimmed = v.replace(COUNTRY_SUFFIX, '').trim();
  return trimmed.length ? trimmed : undefined;
};

export const toDisplayAddress = (src: DisplayAddressSource): DisplayAddress => {
  const road = clean(src.roadAddressEn);
  let jibun = clean(src.jibunAddressEn);
  const detail = clean(src.detail);

  if (road && jibun && road === jibun) {
    jibun = undefined; // 동일 문자열 중복 제거
  }

  if (!road && !jibun) {
    return { fallbackLine: clean(src.legacy), detail };
  }
  return { road, jibun, detail };
};
